import createCachedSelector from "re-reselect";

import { getSearchedLeg, getTripDuration } from "@app/helpers/udm";

import {
  getSearch,
  getTrips,
  getTripsLocations,
  getTripsSegments
} from "../state-accessors";
import { getLegCardById } from "./get-leg-card-by-id";

export interface ShuttleDestination {
  journey_id: string;
  duration: number;
  destination_name: string;
}

export const getUniqueDestinationsForShuttleLegCard = createCachedSelector(
  getSearch,
  getTripsLocations,
  getTrips,
  getTripsSegments,
  getLegCardById,
  (search, locations, trips, trips_segments, trip_ids = []) => {
    const destinations_by_journey_id = trip_ids.reduce(
      (acc, trip_id) => {
        // @ts-expect-error TS2339 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
        const { journey_id } = trips[trip_id];

        if (!acc[journey_id]) {
          const trip = trips[trip_id];
          // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
          const searched_leg = getSearchedLeg(search, trip);
          const trip_segment_ids = searched_leg?.segment_ids || [];
          const trip_segments = trip_segment_ids.map(
            segment_id => trips_segments[segment_id]
          );
          // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
          const duration = getTripDuration(trip_segments);
          const destination_id =
            trip_segments[trip_segments.length - 1]!.destination_id;
          // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
          const destination_name = locations[destination_id].name;

          acc[journey_id] = { journey_id, duration, destination_name };
        }
        return acc;
      },
      {} as Record<string, ShuttleDestination>
    );

    // sort unique destinations by duration shortest first
    return Object.values(destinations_by_journey_id).sort(
      (a, b) => a.duration - b.duration
    );
  }
)((_, leg_card_id) => leg_card_id);
